export const dropDownButtonTestId = 'typeahead-dropdown-button';
export const textFieldTestId = 'typeahead-text-field';
